import { categories, topics } from "@/mocks/topics";
import type { Category, Topic } from "@/types/content";

const allTopics = topics as Topic[];
const allCategories = categories as Category[];

export function getCategories(): Category[] {
  return allCategories;
}

export function getCategoryById(id: string): Category | undefined {
  return allCategories.find((item) => item.id === id);
}

export function getCategoryName(id: string): string {
  return getCategoryById(id)?.name ?? "话题档案";
}

export function getAllTopics(): Topic[] {
  return allTopics;
}

export function getTopicBySlug(slug: string): Topic | undefined {
  return allTopics.find((item) => item.slug === slug);
}

export function getHotTopics(): Topic[] {
  return allTopics.filter((item) => item.hot);
}

export function getLatestTopics(limit?: number): Topic[] {
  const sorted = [...allTopics].sort((a, b) => (a.date < b.date ? 1 : -1));
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getTopicsByCategory(categoryId: string): Topic[] {
  return allTopics.filter((item) => item.category === categoryId);
}

export function countByCategory(categoryId: string): number {
  return allTopics.filter((item) => item.category === categoryId).length;
}

export function getRelatedTopics(slug: string, limit = 3): Topic[] {
  const current = getTopicBySlug(slug);
  if (!current) return getLatestTopics(limit);
  const sameCategory = allTopics.filter(
    (item) => item.slug !== slug && item.category === current.category,
  );
  const others = allTopics.filter(
    (item) => item.slug !== slug && item.category !== current.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function formatDateC(value: string): string {
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return value;
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}